export default __webpack_public_path__ + "static/media/4 - Спортивный досуг во дворах.7882fee1.jpg";